var customer = {

    /**
     * Maps the billing address input ids to the keys returned by the billing address lookup.
     */
    billingFields: {
        "billing_address_1": "address_1",
        "billing_address_2": "address_2",
        "billing_city": "city",
        "billing_state_or_region": "state_or_region",
        "billing_postcode": "postcode"
    },

    listen: function () {

        $("a.copy-to-delivery").on("click", function (event, element) {
            event.preventDefault();
            customer.copyToDelivery(element)
        })

        /**
         * This makes the tabs on the customer edit page change the url
         */
        $('#customerTabs button[data-tab]').on('click', function() {
            const tabName = $(this).attr('data-tab');
            const currentUrl = window.location.pathname;
            const baseUrl = currentUrl.replace(/(\/(details|contacts|quotes|jobs))+$/, '');

            // Update URL without page reload
            window.history.pushState({}, '', baseUrl + '/' + tabName);
        });

        /**
         * When a parent company is chosen the billing address belongs to that parent, so the
         * fields get filled with the parent's address and locked. Clearing it puts theirs back.
         */
        $('#parent_cin7_id').on('change', function () {
            customer.parentChanged($(this).val());
        });
        
    },

    copyToDelivery: function(element) {

        var fields = [
            "_address_1",
            "_address_2",
            "_city",
            "_state_or_region",
            "_postcode"
        ];
        
        fields.forEach(function(field) {
            
            var billName = "billing"+field;
            var delName = "delivery"+field;

            // Delivery address gets billing value
            $("[name="+delName+"]").val($("[name="+billName+"]").val());
        });
    },

    /**
     * Fired when the parent company select changes. An empty value means the customer bills
     * directly, anything else needs a lookup for that parent's billing address.
     */
    parentChanged: function(parentCin7Id) {

        if (!parentCin7Id) {
            customer.showOwnBillingAddress();
            return;
        }

        // The url is rendered with a placeholder id that we swap for the chosen parent
        var url = $("#billing-address-block").data("lookup-url").replace("__CIN7_ID__", parentCin7Id);

        $.getJSON(url)
            .done(function (parent) {
                customer.showInheritedBillingAddress(parent);
            })
            .fail(function () {
                customer.showInheritedBillingAddress(null);
            });
    },

    /**
     * Fill the billing fields with the parent's address and lock them. Pass null to just lock the
     * fields and warn, if the lookup failed.
     */
    showInheritedBillingAddress: function(parent) {

        var $notice = $("#billing-address-inherited").removeClass("d-none");

        if (!parent) {
            $notice.html('<div class="alert alert-warning py-2 mb-3">Could not load the parent company\'s billing address. It will show once you save.</div>');

            $.each(customer.billingFields, function (fieldId) {
                $("#" + fieldId).prop("disabled", true);
            });

            return;
        }

        $notice.html('<div class="alert alert-info py-2 mb-3">Billed to <strong>'
            + customer.escape(parent.name)
            + '</strong>. Edit the address on that customer record.</div>');

        // Disabled fields aren't submitted, so the customer's own stored address is left alone
        $.each(customer.billingFields, function (fieldId, key) {
            $("#" + fieldId).val(parent[key] || "").prop("disabled", true);
        });
    },

    /**
     * Put the customer's own billing address back and unlock the fields.
     */
    showOwnBillingAddress: function() {

        $("#billing-address-inherited").addClass("d-none").empty();

        $.each(customer.billingFields, function (fieldId) {
            var $field = $("#" + fieldId);

            // attr() not data() - data() would coerce a numeric postcode away from a string
            $field.val($field.attr("data-own-value") || "").prop("disabled", false);
        });
    },

    escape: function(value) {
        return $("<div>").text(value == null ? "" : value).html();
    }

}

$(function () {
    customer.listen()
});

module.exports = {
    customer
};